import { createContext, useContext } from 'react';

export const ZoomInfoContext = createContext<number>(1);

export const useZoomInfo = () => {
  const context = useContext(ZoomInfoContext);

  if (!context) {
    throw new Error('useZoomInfo should be used inside a ZoomInfoContext provider');
  }

  return context;
};
